/**
 * Check if the body is overflowing
 *
 * @returns {boolean}
 */
export default () => {
  const rect = document.body.getBoundingClientRect();
  return rect.left + rect.right < window.innerWidth;
};
